export default __webpack_public_path__ + "static/media/recWinter.833370b4.png";